<template>
  <div>
    <div style="margin-bottom: 10px">
      <!-- image des propositions -->
      <!-- si CHOIX UNIQUE -->
      <div v-if="question.element_type == 'radio'">
        <div
          style="max-width: 250px"
          class="illus_answer"
          v-if="answer.file_url"
        >
          <img :src="answer.file_url" />
        </div>
        <div class="radio-group">
          <input
            style=""
            type="radio"
            :name="'q' + question.id"
            :value="answer.id"
            :id="'id' + answer.id"
            @change="emitRadio"
          />
          <label
            v-if="
              answer.proposition_type !== 'content' &&
                choosenLanguageClient === 'fr'
            "
            :for="'id' + answer.id"
            >{{ answer.entitled }}</label
          >
          <label
            v-if="
              answer.proposition_type !== 'content' &&
                choosenLanguageClient === 'en'
            "
            :for="'id' + answer.id"
            >{{ answer.entitled_en }}</label
          >
          <label
            v-if="
              answer.proposition_type !== 'content' &&
                choosenLanguageClient === 'es'
            "
            :for="'id' + answer.id"
            >{{ answer.entitled_es }}</label
          >
          <label
            v-if="
              answer.proposition_type !== 'content' &&
                choosenLanguageClient === 'de'
            "
            :for="'id' + answer.id"
            >{{ answer.entitled_de }}</label
          >
          <!-- gestion des reponses de type "autre" -->
          <label
            v-if="answer.proposition_type == 'content'"
            :for="'id' + answer.id"
            >{{ $t("question.autre.label") }}</label
          >
          <input
            v-if="answer.proposition_type == 'content'"
            type="text"
            :name="'p' + question.id"
            :id="'id' + answer.id"
            :disabled="disabledProp"
            v-model="text"
          />
        </div>
      </div>
      <!-- si CHOIX MULTIPLE -->
      <div v-if="question.element_type == 'checkboxes'">
        <div
          style="max-width: 350px"
          class="illus_answer"
          v-if="answer.file_url"
        >
          <img :src="answer.file_url" />
        </div>
        <div class="checkbox-group">
          <input
            type="checkbox"
            :name="'q' + question.id"
            :value="answer.id"
            :id="'id' + answer.id"
            :check="check"
            @change="emitCheckbox"
          />
          <!-- translation FR -->
          <label
            style="word-wrap: break-word"
            v-if="
              answer.proposition_type != 'content' &&
                choosenLanguageClient === 'fr'
            "
            :for="'id' + answer.id"
            >{{ answer.entitled }}</label
          >
          <!-- translation EN -->
          <label
            style="word-wrap: break-word"
            v-if="
              answer.proposition_type != 'content' &&
                choosenLanguageClient === 'en'
            "
            :for="'id' + answer.id"
            >{{ answer.entitled_en }}</label
          >
          <!-- translation ES -->
          <label
            style="word-wrap: break-word"
            v-if="
              answer.proposition_type != 'content' &&
                choosenLanguageClient === 'es'
            "
            :for="'id' + answer.id"
            >{{ answer.entitled_es }}</label
          >
          <!-- translation ES -->
          <label
            style="word-wrap: break-word"
            v-if="
              answer.proposition_type != 'content' &&
                choosenLanguageClient === 'de'
            "
            :for="'id' + answer.id"
            >{{ answer.entitled_de }}</label
          >
          <label
            v-if="
              question.element_type == 'checkboxes' &&
                answer.proposition_type == 'content'
            "
            :for="'id' + answer.id"
            >{{ $t("question.autre.label") }}</label
          >
          <!-- gestion des reponses de type "autre" -->
          <input
            v-if="
              question.element_type == 'checkboxes' &&
                answer.proposition_type == 'content'
            "
            type="text"
            :name="'p' + question.id"
            :id="'id' + answer.id"
            :disabled="disabledProp"
            v-model="text"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    question: { type: Object },
    answer: '',
    disabledProp: '',
    index: { type: Number }
  },
  data () {
    return {
      text: '',
      check: false
    }
  },
  watch: {
    text () {
      if (this.sections[this.sections.length - 1] !== undefined) {
        if (
          this.answer.conditional_section === -1 ||
          this.steps.nowStep - 1 ===
            this.sections[this.sections.length - 1].questions[
              this.sections[this.sections.length - 1].questions.length - 1
            ].order
        ) {
          this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
        } else {
          this.$store.commit('UPDATE_AUTHORIZED_FORM', false)
        }
      }
      if (this.question.element_type === 'radio') {
        this.$emit('update-field', this.text, this.answer.conditional_section)
      } else {
        this.$emit(
          'update-check',
          this.answer.proposition_type,
          this.answer.id,
          this.text
        )
      }
    }
  },
  computed: {
    ...mapGetters(['sections', 'steps', 'choosenLanguageClient'])
  },
  methods: {
    emitRadio () {
      if (this.answer.proposition_type === 'radio') {
        if (
          this.$store.state.question.type_formulaire === 'simple' &&
          this.$store.state.client.steps.nowStep >=
            this.$store.state.client.steps.stepsLength.length
        ) {
          this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
        }
        // si c'est une section on vérifie si on est à la fin du sondage pour afficher le bouton 'envoyer le formulaire'
        if (this.$store.state.question.type_formulaire === 'section') {
          if (
            this.answer.conditional_section === -1 ||
            this.steps.nowStep - 1 ===
              this.sections[this.sections.length - 1].questions[
                this.sections[this.sections.length - 1].questions.length - 1
              ].order
          ) {
            this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
          } else {
            this.$store.commit('UPDATE_AUTHORIZED_FORM', false)
          }
        }

        this.$emit(
          'update-radio',
          this.answer.proposition_type,
          true,
          this.text,
          this.answer.conditional_section
        )
      } else {
        this.$emit(
          'update-radio',
          this.answer.proposition_type,
          false,
          this.text
        )
      }
    },
    emitCheckbox (e) {
      if (
        this.$store.state.question.type_formulaire === 'simple' &&
        this.$store.state.client.steps.nowStep >=
          this.$store.state.client.steps.stepsLength.length
      ) {
        this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
      }
      if (this.$store.state.question.type_formulaire === 'section') {
        // si c'est une section on vérifie si on est à la fin du sondage pour afficher le bouton 'envoyer le formulaire'
        if (
          this.steps.nowStep - 1 ===
          this.sections[this.sections.length - 1].questions[
            this.sections[this.sections.length - 1].questions.length - 1
          ].order
        ) {
          this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
        } else {
          this.$store.commit('UPDATE_AUTHORIZED_FORM', false)
        }
      }
      this.check = !this.check
      this.$emit(
        'update-check',
        this.answer.proposition_type,
        this.answer.id,
        this.text,
        this.check,
        e.target.type
      )
    }
  }
}
</script>

<style scoped>
.illus_answer img {
  height: 150px;
  width: auto;
  max-width: 100%;
  /*float: left;*/
  border: 1px rgb(20, 18, 18) dotted;
}

/* custom radio */
[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #666;
}
[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #ddd;
  border-radius: 100%;
  background: #fff;
}
[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
  content: "";
  width: 12px;
  height: 12px;
  background: #424a60;
  position: absolute;
  top: 3px;
  left: 3px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
[type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}

/* CUSTOM CHECKBOX */
[type="checkbox"]:checked,
[type="checkbox"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type="checkbox"]:checked + label,
[type="checkbox"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #666;
}
[type="checkbox"]:checked + label:before,
[type="checkbox"]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #ddd;
  background: #fff;
}
[type="checkbox"]:checked + label:after,
[type="checkbox"]:not(:checked) + label:after {
  content: "";
  display: block;
  position: absolute;
  top: 0px;
  left: 6px;
  width: 6px;
  height: 14px;
  border: 1px solid #424a60;
  border-width: 0 2px 2px 0;
  transform: rotate(30deg);
}
[type="checkbox"]:not(:checked) + label:after {
  opacity: 0;
}
[type="checkbox"]:checked + label:after {
  opacity: 1;
}
/* .checkbox-group {
  display: block;
  margin-bottom: 2px;
}

.checkbox-group input[type="checkbox"] {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}

.checkbox-group label {
  position: relative;
  cursor: pointer;
}

.checkbox-group label:before {
  content: "";
  -webkit-appearance: none;
  background-color: transparent;
  border: 1px solid #ddd;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 10px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 5px;
}

.checkbox-group input:checked + label:after {
  content: "";
  display: block;
  position: absolute;
  top: 5px;
  left: 9px;
  width: 6px;
  height: 14px;
  border: 1px solid #424a60;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
} */
label {
  font-weight: bold;
  font-size: 12px;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/formulaire/formulaire_layouts/proposition.vue